export const REACT_APP_ENCRYPTION_KEY = "aNanDArESoRT@1234!#$%&*";
export const REACT_APP_BASE_URL= "https://stg-api.anandaspa.com";
